import React from 'react';
import { PH } from './glossaryData'; // 👈 Tu diccionario salvavidas

// ─────────────────────────────────────────────────────────────────
// 🚀 SINTETIZADOR FONÉTICO INTELIGENTE (LA CURA DEFINITIVA)
// ─────────────────────────────────────────────────────────────────
function getRobustPhonetic(wordObj, dict) {
  // 1. Intentamos leerlo directo de la BD (si se lo pusiste manual en Neon, gana esto)
  let rawPh = wordObj.ph || wordObj.phonetic || wordObj.pronunciation || wordObj.pron;
  const cleanWord = wordObj.en.trim().toLowerCase();

  // 2. Si viene vacío de la BD, usamos el diccionario PH
  if (!rawPh && dict) {
    if (dict[cleanWord]) {
      // 2a. Existe la palabra/frase exacta en el diccionario
      rawPh = dict[cleanWord];
    } else if (cleanWord.includes(' ')) {
      // 2b. 🧠 ¡MAGIA DE COLOCACIONES! Es una frase. La partimos palabra por palabra.
      const words = cleanWord.split(/\s+/);
      const phoneticParts = words.map(w => {
        const stripped = w.replace(/[.,!?;:'"()]/g, ''); // Quitamos signos de exclamación
        const found = dict[stripped];
        // Si encontramos la palabra, le quitamos sus / / para unirlas limpias
        return found ? found.replace(/[\/\[\]]/g, '') : stripped; 
      });
      
      // Si logramos traducir al menos una palabra, armamos la frase fonética
      const successCount = phoneticParts.filter((t, i) => t !== words[i].replace(/[.,!?;:'"()]/g, '')).length;
      if (successCount > 0) {
        rawPh = phoneticParts.join('  '); // Doble espacio para que se lea claro
      }
    }
  }

  // 3. Limpiador estético final: Quitamos / y [ ] para que nuestro componente 
  // los ponga de forma uniforme y elegante en pantalla.
  return rawPh ? rawPh.replace(/[\/\[\]]/g, '').trim() : null;
}

export default function MicDisplay({ q, mic, onSkipCorrect, onSkipWrong }) {
  const word = q.word.en;
  const isShort = word.replace(/\s/g, '').length <= 3;
  
  // 🚀 PASAMOS LA PALABRA POR EL SINTETIZADOR
  const phoneticText = getRobustPhonetic(q.word, PH);

  // ── Fallback: SR no disponible en este browser ───────────────
  if (!mic.isSupported) {
    return (
      <>
        <div className="mga-section-lbl">🎙️ Pronunciation</div>
        <div className="mga-big-word" style={{ marginBottom: '0.2rem' }}>{word}</div>
        
        {phoneticText && (
          <div className="mga-phonetic-hero" style={{ transform: 'scale(0.8)', marginBottom: '1rem' }}>
            [ {phoneticText} ]
          </div>
        )}
        
        <p className="mga-mic-no-support">Speech recognition not available in this browser.</p>
        <div className="mga-opts-grid" style={{ marginTop: '.75rem' }}>
          <button className="mga-opt-btn" onClick={onSkipCorrect}>✓ Said it correctly</button>
          <button className="mga-opt-btn" onClick={onSkipWrong}>✗ Skip</button>
        </div>
      </>
    );
  }

  const isListening = mic.isListening;

  // ── UI principal ─────────────────────────────────────────────
  return (
    <>
      <div className="mga-section-lbl" style={{ color: '#f43f5e' }}>🎙️ Say it out loud!</div>
      
      {/* Palabra objetivo */}
      <div className="mga-big-word" style={{ marginBottom: '0.2rem' }}>
        {word}
      </div>

      {/* 🌟 FONÉTICA GIGANTE INTELIGENTE */}
      {phoneticText ? (
        <div className="mga-phonetic-hero">
          [ {phoneticText} ]
        </div>
      ) : (
        <div className="mga-phonetic-hero" style={{ opacity: 0.25, color: 'var(--tx2)' }}>
          [ /.../ ]
        </div>
      )}

      {/* Tip extra solo para palabras muy cortas */}
      {isShort && (
        <div className="mga-mic-hint" style={{ marginBottom: '.5rem', color: 'var(--wa)', fontWeight: 700 }}>
          ⚡ Short word — speak slowly and clearly
        </div>
      )}

      <div className={`mga-mic-status ${isListening ? 'rec' : 'ready'}`}>
        {isListening ? '● Listening…' : mic.status === 'error' ? '● Try Again' : '● Ready'}
      </div>

      <button
        className={`mga-mic-btn${isListening ? ' listening' : ''}`}
        onClick={() => mic.toggle(word)}
        disabled={mic.status === 'done' || isListening}
        aria-label="Start recording"
      >
        🎤
      </button>

      {mic.result.text && (
        <div className={`mga-mic-result ${mic.result.type}`}>
          {mic.result.text}
        </div>
      )}

      {!mic.result.text && (
          <div className="mga-mic-hint">
            Press the mic, say the word clearly, and get instant feedback
          </div>
      )}
    </>
  );
}